import Button, { ButtonProps } from '@lyra/core/components/Button'
import Tooltip, { TooltipProps } from '@lyra/core/components/Tooltip'
import { TokenId } from '@lyra/web/constants/tokens'
import { useState } from 'react'

import WithdrawModal from './WithdrawModal'

type Props = {
  defaultToken?: TokenId
  tooltipProps?: Omit<TooltipProps, 'trigger'>
} & Omit<ButtonProps, 'label' | 'onPress'>

export default function WithdrawButton({ defaultToken, tooltipProps, ...props }: Props) {
  const [isOpen, setIsOpen] = useState(false)

  const button = (
    <Button
      {...props}
      label="Withdraw"
      onPress={(e) => {
        e.stopPropagation()
        setIsOpen(true)
      }}
    />
  )

  const wrappedButton = tooltipProps ? <Tooltip {...tooltipProps} trigger={button} /> : button

  return (
    <>
      {wrappedButton}
      {isOpen ? (
        <WithdrawModal onClose={() => setIsOpen(false)} defaultToken={defaultToken} />
      ) : null}
    </>
  )
}
